$(document).ready(function(){

  var CLOSE_MS = 350;

  function openPanel($panel, $title){
    clearTimeout($panel.data('tglClose'));
    $panel.removeClass('is-closing').addClass('on');
    $title.addClass('on');
  }

  function closePanel($panel, $title){
    if (!$panel.hasClass('on') || $panel.hasClass('is-closing')) return;
    $panel.addClass('is-closing');
    $panel.data('tglClose', setTimeout(function(){
      $panel.removeClass('on is-closing');
      $title.removeClass('on');
    }, CLOSE_MS));
  }

  function isOpen($panel){
    return $panel.hasClass('on') && !$panel.hasClass('is-closing');
  }

  $(".cattitle").click(function(){
    var $menu = $(".allcats");
    if (isOpen($menu)) {
      closePanel($menu, $(".cattitle"));
    } else {
      openPanel($menu, $(".cattitle"));
      closePanel($(".searchholder"), $(".searchtitle"));
    }
  });

  $(".searchtitle").click(function(){
    var $search = $(".searchholder");
    if (isOpen($search)) {
      closePanel($search, $(".searchtitle"));
    } else {
      openPanel($search, $(".searchtitle"));
      closePanel($(".allcats"), $(".cattitle"));
    }
  });

});